import { TEMPLATE_MODELS } from '~constants/templates';
import { CLIENT_PAGES } from '~constants/pages';

import OpenLoginModalButton from '../OpenLoginModalButton';

import Actionlinks from './components/Actionlinks';
import ProfileMenu from './components/ProfileMenu';
import Logo from './components/Logo';
import Minicart from './components/Minicart';
import LogoutButton from './components/LogoutButton';
import styles from './styles.module.scss';

export const PROFILE_MENU = 'profileMenu';
export const LOGO = 'logo';
export const ACTION_LINKS = 'actionLinks';
export const MINI_CART = 'miniCart';
export const LOGOUT_BUTTON = 'logoutButton';

export const TEMPLATE_MODEL_COMPONENTS = {
  [TEMPLATE_MODELS.SUSHI]: {
    alignmentClassName: 'row middle full-width',
    firstComponent: {
      component: ProfileMenu,
      className: '',
      name: PROFILE_MENU
    },
    secondComponent: {
      component: Logo,
      className: `m-right-2 ${styles.navBarLogo}`,
      props: {
        classNameLog: styles.navBarLogo,
        name: LOGO,
        homePath: CLIENT_PAGES.HOME.basePath
      }
    },
    thirdComponent: {
      component: Actionlinks,
      className: '',
      name: ACTION_LINKS
    },
    fourthComponent: {
      component: OpenLoginModalButton,
      className: '',
      name: PROFILE_MENU,
      props: {
        hasUserIcon: true,
        showWelcomeMessage: false,
        className: styles.userIconGeneric
      }
    },
    fifthComponent: {
      component: Minicart,
      className: '',
      name: MINI_CART
    },
    sixthComponent: {
      component: LogoutButton,
      className: '',
      name: LOGOUT_BUTTON
    }
  },
  [TEMPLATE_MODELS.GENERIC]: {
    alignmentClassName: 'row middle full-width',
    firstComponent: {
      component: ProfileMenu,
      className: '',
      name: PROFILE_MENU
    },
    secondComponent: {
      component: Logo,
      className: `m-right-2 ${styles.navBarLogo}`,
      props: {
        classNameLog: styles.navBarLogo,
        name: LOGO,
        homePath: CLIENT_PAGES.HOME.basePath
      }
    },
    thirdComponent: {
      component: Actionlinks,
      className: '',
      name: ACTION_LINKS
    },
    fourthComponent: {
      component: OpenLoginModalButton,
      className: '',
      name: PROFILE_MENU,
      props: {
        hasUserIcon: false,
        showWelcomeMessage: false,
        className: styles.userIconGeneric,
        hasUserImage: true
      }
    },
    fifthComponent: {
      component: Minicart,
      className: '',
      name: MINI_CART
    },
    sixthComponent: {
      component: LogoutButton,
      className: '',
      name: LOGOUT_BUTTON
    }
  },
  [TEMPLATE_MODELS.BURGERS]: {
    alignmentClassName: 'row middle full-width',
    firstComponent: {
      component: ProfileMenu,
      className: '',
      name: PROFILE_MENU
    },
    secondComponent: {
      component: Logo,
      className: `m-right-2 ${styles.navBarLogo}`,
      props: {
        classNameLog: styles.navBarLogo,
        name: LOGO,
        homePath: CLIENT_PAGES.HOME.basePath
      }
    },
    thirdComponent: {
      component: Actionlinks,
      className: '',
      name: ACTION_LINKS
    },
    fourthComponent: {
      component: OpenLoginModalButton,
      className: '',
      name: PROFILE_MENU,
      props: {
        hasUserIcon: true,
        className: styles.userIconBurgers
      }
    },
    fifthComponent: {
      component: Minicart,
      className: '',
      name: MINI_CART
    },
    sixthComponent: {
      component: LogoutButton,
      className: '',
      name: LOGOUT_BUTTON
    }
  }
};
